import { createSlice } from "@reduxjs/toolkit";
import { classesApi } from "../services/classesApi";

const initialState = {
    data: [],
};

export const classesSlice = createSlice({
    name: "classes",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addMatcher(
                classesApi.endpoints.getClassesByBatchId.matchFulfilled,
                (state, { payload }) => {
                    state.data = payload.data;
                }
            )
            .addMatcher(
                classesApi.endpoints.getClassesByBatchId.matchRejected,
                (state, { payload }) => {
                    state.data = [];
                }
            );
        builder
            .addMatcher(
                classesApi.endpoints.enrollClass.matchFulfilled,
                (state, { payload, meta }) => {
                    const params = meta.arg.originalArgs || {}

                    state.data = state?.data?.map(item => {
                        if (item.id !== params.class_id) return item;
                        return {
                            ...item,
                            is_enrolled: 1
                        }
                    })
                }
            )
            .addMatcher(
                classesApi.endpoints.enrollClass.matchRejected,
                (state, { payload }) => { }
            );

        builder
            .addMatcher(
                classesApi.endpoints.attendClass.matchFulfilled,
                (state, { payload, meta }) => {
                    const id = meta.arg.originalArgs || {}

                    state.data = state?.data?.map(item => {
                        if (item.id !== id) return item;
                        return {
                            ...item,
                            is_completed: 1
                        }
                    })
                }
            )
            .addMatcher(
                classesApi.endpoints.attendClass.matchRejected,
                (state, { payload }) => { }
            )
    },
});

export const { } = classesSlice.actions;

export default classesSlice.reducer;
